import { render, staticRenderFns } from "./Inscricoes.vue?vue&type=template&id=fe1ee724&scoped=true"
import script from "./Inscricoes.vue?vue&type=script&lang=js"
export * from "./Inscricoes.vue?vue&type=script&lang=js"
import style0 from "./Inscricoes.vue?vue&type=style&index=0&id=fe1ee724&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe1ee724",
  null
  
)

export default component.exports